import DiscoveryCategoriesDetails from './DiscoveryCategoriesDetails.container';

export default DiscoveryCategoriesDetails;
